import React from "react";
import "./HaqtSpinner.scss";

const HaqtSpinner = () => {
  return (
    <div className="haqt-spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default HaqtSpinner;
